import {MODULE_STATE_NAME} from './constants'

// Actions
export const AUTHENTICATE = `${MODULE_STATE_NAME}/AUTHENTICATE`
export const AUTHENTICATE_SUCCESS = `${MODULE_STATE_NAME}/AUTHENTICATE-SUCCESS`
export const AUTHENTICATE_ERROR = `${MODULE_STATE_NAME}/AUTHENTICATE-ERROR`
export const LOGOUT = `${MODULE_STATE_NAME}/LOGOUT`
